import { render, staticRenderFns } from "./products_weights.page.vue?vue&type=template&id=28560be0&"
import script from "./products_weights.page.vue?vue&type=script&lang=js&"
export * from "./products_weights.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports